import { ChangeDetectionStrategy, Component, NgModule } from '@angular/core';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { NgOtpInputModule } from 'ng-otp-input';
import { FormFieldModule } from '../wrapper/form-field/form-field.component';
import { NgxMaskModule } from 'ngx-mask';
import { ReactiveFormsModule } from '@angular/forms';
import { CyTestDirective } from '@portal/directive';
import { PortalFieldTypeConfig } from '@portal/form/data-access';

@Component({
  selector: 'portal-form-otp',
  standalone: true,
  imports: [NgOtpInputModule, NgxMaskModule, ReactiveFormsModule, CyTestDirective],
  template: `
    <ng-otp-input
      class="field-otp"
      [id]="id"
      [portalCyTest]="field.key"
      [formCtrl]="formControl"
      [class.field-invalid]="showError"
      [config]="config"
    ></ng-otp-input>
  `,
  styles: [':host {@apply block mt-2;} ::ng-deep .mat-error {@apply text-xs;}'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OtpComponent extends FieldType<PortalFieldTypeConfig> {
  get config() {
    return this.props.otpConfig || { length: 6 };
  }

  /**
   * Check if form or field is disabled
   * @returns boolean
   * @readonly
   */
  get disabled(): boolean {
    return !!this.options?.formState?.disabled || !!this.props?.disabled;
  }
}

@NgModule({
  imports: [
    FormFieldModule,
    FormlyModule.forChild({
      types: [{ name: 'otp', component: OtpComponent, wrappers: ['form-field'] }],
    }),
  ],
})
export class FormOtpModule {}
